import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import { Select } from "@shopify/polaris";

RHFSelect.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

export default function RHFSelect({ name, options, label, disabled = false, numeric = false, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <Select
            label={label}
            options={options}
            value={field.value != null ? String(field.value) : ""}
            onChange={(value) => field.onChange(numeric ? Number(value) : value)}
            disabled={disabled}
            {...other}
          />
          {error && <div style={{ color: "red", marginTop: "4px" }}>{error.message}</div>}
        </div>
      )}
    />
  );
}
